import React from "react";
import { DropdownChangeParams } from "primereact";
import { Input } from "../../../../components/form/formik/input/styles";
import { DropdownStyled } from "../../../../components/form-factory/styled";

type FiltersProps = {
  onSubmit: (value: any) => void
}

export const Filters = ({ onSubmit }: FiltersProps): JSX.Element => {
  const [filter, setFilter] = React.useState<any | undefined>();
  const ref = React.useRef<NodeJS.Timeout | null>(null);

  const handleSubmit = (e: string): void => {
    setFilter((prev: any) => ({ ...prev, query: e }));

    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      onSubmit({ ...filter, query: e, page: 0 });
    }, 500);
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <span>Buscar:</span>
      <Input
        onChange={(e) => {
          handleSubmit(e.target.value);
        }}
        placeholder="Buscar..."
        value={filter?.query}
      />
      <DropdownStyled
        name="filter"
        disabled={false}
        options={[
          { value: 0, label: "Todos" },
          { value: "CREATED", label: "Criada" },
          { value: "INTEGRATION_SENT", label: "Integração - Enviada" },
          { value: "INTEGRATION_FAILED", label: "Integração - Falha no Envio" },
          { value: "INTEGRATION_SUCCESS", label: "Integração - Sucesso" },
          { value: "INTEGRATION_ERROR", label: "Integração - Erro" },
          { value: "INTEGRATION_TIMEOUT", label: "Integração - Timeout" },
          { value: "INTEGRATION_CANCEL_REQUESTED", label: "Integração - Cancelamento Solicitado" },
          { value: "INTEGRATION_CANCELED", label: "Integração - Cancelada" },
          { value: "INTEGRATION_CANCEL_FAILED", label: "Integração - Falha no Cancelamento" },
        ]}
        placeholder="Status"
        value={filter?.status}
        optionLabel="label"
        optionValue="value"
        emptyMessage="Nenhuma opção encontrada"
        style={{
          marginBottom: 0,
          width: "500px",
          marginLeft: "15px",
          color: "white",
        }}
        onChange={(e: DropdownChangeParams) => {
          setFilter((prev: any) => ({
            ...prev,
            status: e.target.value,
          }));

          onSubmit({ ...filter, filters: { ...filter.filters, status: e.target.value }, page: 0 });
        }}
      />
    </div>
  );
};